import axios from 'axios'
import { environment } from '@/data/environment/'

export default {
  namespaced: true,
  state: {
    statusResponse: null,
    statusResponseMsg: '',
    updateStatusResponse: false,
    updateFabricanteResponse: false,
    updateEmailFEResponse: false,
    updateEmailDeliveryResponse: false,
    updateUserResponse: false,
    listClients: [],
    statusGenerateReportMessage: '',
    statusGenerateReportStatus: null,
    statusGeneratePendingReportMessage: '',
    statusGeneratePendingReportStatus: null,
  },
  mutations: {

    setListClients (state, data) {
      state.listClients = data
    },
    setResponseClient (state, data) {
      state.statusResponse = data
    },
    setResponseClientMsg (state, data) {
      state.statusResponseMsg = data
    },
    setUpdateResponseClient (state, data) {
      state.updateStatusResponse = data
    },
    setUpdateResponseFabricante (state, data) {
      state.updateFabricanteResponse = data
    },
    setUpdateResponseEmailFE (state, data) {
      state.updateEmailFEResponse = data
    },
    setUpdateResponseEmailDelivery (state, data) {
      state.updateEmailDeliveryResponse = data
    },
    setUpdateResponseUser (state, data) {
      state.updateUserResponse = data
    },
    setStatusResponseDownloadReportFileMsg (state, data) {
      state.statusGenerateReportMessage = data
    },
    setStatusResponseDownloadReportFile (state, data) {
      state.statusGenerateReportStatus = data
    },
    setStatusResponseDownloadPendingReportFileMsg (state, data) {
      state.statusGeneratePendingReportMessage = data
    },
    setStatusResponseDownloadPendingReportFile (state, data) {
      state.statusGeneratePendingReportStatus = data
    },
  },
  actions: {
    getListClients ({ commit }) {
      const endpoint = '/api/getClients'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setListClients', response.data)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    insertClients ({ commit }, data) {
      const endpoint = '/api/insertClients'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      data.user = JSON.parse(atob(localStorage.getItem('uid'))).user

      const urlCertificateProd = "https://gestioncontribuyentesrest.thefactoryhka.com.co/api"
      const urlCertificateDemo = "https://demogestioncontribuyentesrest.thefactoryhka.com.co/api"

      if(data.Proveedor === "1") {
        if (data.Estado === "P") {
          data.UrlApiGestion = urlCertificateProd
        } else {
          data.UrlApiGestion = urlCertificateDemo
        }
      } else {
        data.UrlApiGestion = "URL_EDN"
      }

      axios
        .create()
        .post(url, data)
        .then(response => {
          if (response.data) {
              commit('setResponseClient', response.data.error)
              commit('setResponseClientMsg', response.data.Mensaje)
          }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    activeInactiveClient ({ commit }, data) {
      const endpoint = '/api/updateStatusClient'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      data.user = JSON.parse(atob(localStorage.getItem('uid'))).user

      axios
        .create()
        .post(url, data)
        .then(response => {
          if (response.data.Mensaje) {
            commit('setUpdateResponseClient', response.data.Mensaje)
          }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    updateFabricante ({ commit }, data) {
      const endpoint = '/api/updateFabricante'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      data = {'FabricanteSoftware':data.fabricante,'Nit':data.nit,'RazonSocialDistribuidor':data.razon_social,
         'Distribuidor':data.distribuidor, 'TokenEnterprise':data.token_enterprise, 'TokenPassword':data.token_password,
        'User':data.user }
      axios
          .create()
          .put(url, data)
          .then(response => {
            commit('setUpdateResponseFabricante', response.statusText == "OK")
          })
          .catch(function (error) {
            console.log(error.message)
          })
    },
    updateEmailFE ({ commit }, data) {
      const endpoint = '/api/updateEmailFE'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      data = {'Email':data.email,'TokenEnterprise':data.token_enterprise, 'TokenPassword':data.token_password,
        'User':data.user }
      axios
        .create()
        .put(url, data)
        .then(response => {
          commit('setUpdateResponseEmailFE', response.statusText == "OK")
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    updateEmailDelivery ({ commit }, data) {
      const endpoint = '/api/updateEmailDelivery'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      data = {'Email':data.email,'TokenEnterprise':data.token_enterprise, 'TokenPassword':data.token_password,
        'User':data.user }
      axios
        .create()
        .put(url, data)
        .then(response => {
          commit('setUpdateResponseEmailDelivery', response.statusText == "OK")
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    updateUser ({ commit }, data) {
      const endpoint = '/api/updateUser'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      data = {
        'NombreCompania':data.NombreCompania,
        'NitCliente':data.NitCliente,
        'ProveedorTecnologico':data.ProveedorTecnologico,
        'TokenEnterprise':data.TokenEnterprise,
        'TokenPassword':data.TokenPassword,
        'Url':data.Url,
        'UrlApiGestion':data.UrlApiGestion,
        'InformacionAdicional':data.InformacionAdicional,
        'Estado':data.Estado,
        'EmailDelivery':data.EmailDelivery,
        'EmailFE':data.EmailFE,
        'User':data.user,
        'IdCompania':data.IdCompania,
       }

      axios
        .create()
        .put(url, data)
        .then(response => {
          commit('setUpdateResponseUser', response.statusText == "OK")
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    generateProcessedInvoicesReport ({ commit }, data) {
      let params = `&IdCompania=${data.idCompania}`
      if (data.dateRange) {
        if (data.dateRange[1] === undefined) {
          params += `&FechaInicial=${data.dateRange[0]}`
          params += `&FechaFinal=${data.dateRange[0]}`
        } else {
          let FechaInicial = data.dateRange[0]
          let FechaFinal = data.dateRange[1]
          const FechaInicialObj = new Date(FechaInicial)
          const FechaFinalObj = new Date(FechaFinal)
          if (FechaInicialObj > FechaFinalObj) {
            const temp = FechaInicial
            FechaInicial = FechaFinal
            FechaFinal = temp
          }
          params += `&FechaInicial=${FechaInicial}`
          params += `&FechaFinal=${FechaFinal}`
        }
      }
      if (data.email) {
        params += `&Email=${data.email}`
      }

      if (data.nombreCompania) {
        params += `&NombreCompania=${data.nombreCompania}`
      }

      if (data.todasCompanias) {
        params += '&TodasCompanias=' + data.todasCompanias
      } else {
        params += '&TodasCompanias=' + false
      }
      const endpoint = '/api/processedInvoicesReport?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params
      axios
        .create()
        .post(url)
        .then(response => {
          if (response.data.Error) {
            commit('setStatusResponseDownloadReportFileMsg', 'Error en el intento de generar reporte.')
            commit('setStatusResponseDownloadReportFile', false)
          } else {
            commit('setStatusResponseDownloadReportFileMsg', 'Reporte generado correctamente.')
            commit('setStatusResponseDownloadReportFile', true)
          }
        })
        .catch(error => {
          console.error('Error descargando el archivo:', error.message)
          commit('setStatusResponseDownloadReportFileMsg', 'Error en el intento de generar reporte.')
          commit('setStatusResponseDownloadReportFile', false)
        })
    },
    generatePendingInvoicesReport ({ commit }, data) {
      let params = `&IdCompania=${data.idCompania}`
      if (data.dateRange) {
        if (data.dateRange[1] === undefined) {
          params += `&FechaInicial=${data.dateRange[0]}`
          params += `&FechaFinal=${data.dateRange[0]}`
        } else {
          let FechaInicial = data.dateRange[0]
          let FechaFinal = data.dateRange[1]
          const FechaInicialObj = new Date(FechaInicial)
          const FechaFinalObj = new Date(FechaFinal)
          if (FechaInicialObj > FechaFinalObj) {
            const temp = FechaInicial
            FechaInicial = FechaFinal
            FechaFinal = temp
          }
          params += `&FechaInicial=${FechaInicial}`
          params += `&FechaFinal=${FechaFinal}`
        }
      }
      if (data.email) {
        params += `&Email=${data.email}`
      }

      if (data.nombreCompania) {
        params += `&NombreCompania=${data.nombreCompania}`
      }

      if (data.todasCompanias) {
        params += '&TodasCompanias=' + data.todasCompanias
      } else {
        params += '&TodasCompanias=' + false
      }
      console.log('Parametros : ' + params)
      const endpoint = '/api/pendingInvoicesReport?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params
      axios
        .create()
        .post(url)
        .then(response => {
          if (response.data.Error) {
            commit('setStatusResponseDownloadPendingReportFileMsg', 'Error en el intento de generar reporte de facturas pendientes.')
            commit('setStatusResponseDownloadPendingReportFile', false)
          } else {
            commit('setStatusResponseDownloadPendingReportFileMsg', 'Reporte de facturas pendientes generado correctamente.')
            commit('setStatusResponseDownloadPendingReportFile', true)
          }
        })
        .catch(error => {
          console.error('Error descargando el archivo:', error.message)
          commit('setStatusResponseDownloadPendingReportFileMsg', 'Error en el intento de generar reporte de facturas pendientes.')
          commit('setStatusResponseDownloadPendingReportFile', false)
        })
    },
    setStatusResponse ({ commit }, data) {
      commit('setResponseClient', data)
    },
    setStatusResponseMsg ({ commit }, data) {
      commit('setResponseClientMsg', data)
    },
    setUpdateResponseClient ({ commit }, data) {
      commit('setUpdateResponseClient', data)
    },
    setUpdateResponseFabricante ({ commit }, data) {
      commit('setUpdateResponseFabricante', data)
    },
    setUpdateResponseEmailFE ({ commit }, data) {
      commit('setUpdateResponseEmailFE', data)
    },
    setUpdateResponseEmailDelivery ({ commit }, data) {
      commit('setUpdateResponseEmailDelivery', data)
    },
    setUpdateResponseUser ({ commit }, data) {
      commit('setUpdateResponseUser', data)
    },
    setStatusResponseDownloadReportFileMsg ({ commit }, data) {
      commit('setStatusResponseDownloadReportFileMsg', data)
    },
    setStatusResponseDownloadReportFile ({ commit }, data) {
      commit('setStatusResponseDownloadReportFile', data)
    },
    setStatusResponseDownloadPendingReportFileMsg ({ commit }, data) {
      commit('setStatusResponseDownloadPendingReportFileMsg', data)
    },
    setStatusResponseDownloadPendingReportFile ({ commit }, data) {
      commit('setStatusResponseDownloadPendingReportFile', data)
    },
  },
}
